<template>
  <div class="dish-list">
    <h2 class="dish-list-title">{{$t('menu_settings.additions')}}</h2>

    <div class="dish-list-body">

        <div class="dish-list-scroll" id="list">
          <div v-for="(modificator, index) in modificators" :key="`${modificator._id}-${index}`">
            <div
              :class="{
                  dish: true,
                  currentDish: index == selected_index
              }"
              @click="onSelect(index)"
            >
              <div class="dish-body">
                <img :src="modificator.image ? modificator.image : '/icons/no-dish.png'" />
                <div class="dish-info">
                  <h3>{{ modificator.name }}</h3>
                  <!-- <p>{{ product.description }}</p> -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div
          class="dish-add"
          @click="showAddDishUI"
          v-if="!rearrange.active && !availability.active && !exclusives_category"
        >
          <button>{{ $t('dish_list.add_dish') }}</button>
        </div> -->

    </div>
  </div>
</template>




<script>
export default {
  data() {
    return {
      selected_index: -1
    };
  },
  props: {

  },
  watch: {

  },
  components: {

  },
  methods: {
    onSelect(index) {
      this.selected_index = index;
      this.$emit('select', this.modificators[this.selected_index]);
    }
  },
  mounted() {

  },
  computed: {
    modificators() {
        return this.$store.getters['menu/modificatorsList'];
    }
  }
};
</script>


<style scoped>
.dish-list {
  width: 37vh;
  margin-right: 3vh;
  display: block;
}
.dish-list-title {
  font-weight: 500;
  font-size: 3vh;
  color: #ffffff;
  margin-bottom: 0;
}
.dish-list-border {
  position: relative;
}

.dish-list-scroll {
  overflow-y: auto;
  height: 56vh;
    border: 1px solid #c4c4c4;
    border-radius: 1.5vh;
}

.dish-add button {
  border: 1px solid #cbd9e6;
  box-sizing: border-box;
  border-radius: 1vh;
  background: #464646;

  color: #cbd9e6;
  width: 100%;
  height: 9.5vh;

  transition: 0.3s;
  cursor: pointer;
  font-weight: 500;
  font-size: 2.6vh;
  position: absolute;
  bottom: 0;
}

.dish-add button:hover {
  color: #000;
  background: #cbd9e6;
}

.dish-list-body {
  position: relative;
  padding-top: 1.7vh;
}

.dish-body {
  display: flex;
  padding: 1.65vh;
  align-items: center;
}

.dish-body img {
  width: 6.7vh;
  height: 6.7vh;
  object-fit: cover;
  border-radius: 1vh;
  margin-right: 1.7vh;
}

.dish-info h3 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 55%;
  font-weight: 500;
  font-size: 2vh;
  line-height: 100%;
  position: absolute;
  top: 1.5vh;
  margin-bottom: 0;
  color: #ededed;
}

.dish-info p {
  width: 22vh;

  font-weight: 500;
  font-size: 1.1vh;
  line-height: 130.8%;
  color: #a4a3a1;
  margin: 0;
  padding-top: 2vh;
  height: 6.2vh;
  overflow: hidden;
  display: block;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.currentDish {
  background: #cbd9e6;
}
.currentDish div p {
  color: #a4a3a1;
}
.currentDish div h3 {
  color: #1d1d1b;
}

.dish-number {
  position: absolute;
  right: 2.2vh;
  top: 3.5vh;
  width: 3vh;
  height: 3vh;
  background: #464646;
  border-radius: 5vh;

  font-weight: 500;
  font-size: 2.2vh;
  display: flex;
  align-items: center;

  justify-content: center;
  color: #ededed;
}

.dish-number img.tabs {
  width: 4vh;
  height: 4vh;
}

.dish-btn {
  display: flex;
  margin-top: 3.3vh;
}

.rearrange {
  width: 10vw;
  height: 2.8vw;

  border: 0.06vw solid #a4a3a1;
  box-sizing: border-box;
  border-radius: 1.4vw;
  background: #464646;
  color: #fff;

  font-weight: 500;
  font-size: 1.33vw;
  /* line-height: 23px; */
  display: flex;
  justify-content: center;

  color: #a4a3a1;

  cursor: pointer;
  margin-top: 3.5vh;
}

.dish-list-editor {
  position: relative;
  background: #5f5f5f;
}
.dish-info-edit {
  padding-left: 0.53vw;
  padding-right: 0.53vw;
}
.dish-info-edit div {
  display: flex;
}

.dish-price-edit,
.dish-title-edit {
  background: #ffffff;
  border-radius: 0.4vw;
  border: 0;
  padding-left: 0.8vw;
  outline: none;
}

.dish-price-edit {
  text-align: center;
  padding: 0;
}

.dish-desc-edit {
  width: 21vw;
  height: 5.3vw;

  background: #ffffff;
  border-radius: 0.4vw;

  font-size: 1.06vw;
  line-height: 130.8%;

  color: #464646;

  border: 0;

  margin-top: 0.53vw;
  outline: none;
  padding-left: 0.66vw;
}

.dish-price-edit {
  width: 5.06vw;
  height: 2.466vw;
  margin-left: 2.13vw;

  font-weight: 500;
  font-size: 2vw;
  /* line-height: 35px; */

  color: #000000;
}
.dish-title-edit {
  width: 14vw;
  height: 2.46vw;

  font-weight: bold;
  font-size: 1.33vw;
  /* line-height: 23px; */

  color: #000000;
}

.done {
  border: 0.06vw solid #129b81;
  color: #129b81;
}
.rearrange-buttons {
  margin-top: 3.5vh;
  outline: none;

  display: flex;
  justify-content: center;
}

.dish-list-editor img {
  width: 110%;
  position: relative;
  left: -0.3vw;
  /* filter: blur(4px); */

  width: 22.666vw;
  height: 14.2vw;
  margin-bottom: 2vw;
}

.dish-list-editor button {
  position: absolute;
  top: 5.66vw;
  left: 6.46vw;

  border: 0;
  color: #fff;
  padding: 0.73vw;
  padding-left: 2.8vw;
  border-radius: 0.8vw;

  font-weight: bold;
  font-size: 1.33vw;
  /* line-height: 23px; */
  cursor: pointer;

  background: url("/change.png") 13px no-repeat;
  background-color: #464646;
  background-size: 1.66vw;
}

.dish {
  position: relative;
  transition: 0.1s;
  cursor: pointer;
}

.addition {
  margin-top: 1.33vw;
  display: block !important;
  margin-left: 0.8vw;
  margin-right: 0.8vw;
}
.addition h3 {
  font-weight: 500;
  font-size: 1.066vw;
  /* line-height: 19px; */
  color: #ffffff;
}
.addition-body {
  display: flex;
}

.dish-availability-toggle {
  border-radius: 50%;
  border: 0.3vh solid #1d1d1b;

  display: flex;
  align-items: center;

  justify-content: center;

  position: absolute;
  right: 2.2vh;
  top: 3.3vh;
  width: 3.5vh;
  height: 3.5vh;
  background-color: #a4a3a1;
}

.dish-availability-toggle-active {
  background-color: #129b81;
}

.rearrange-ghost {
  background: #cbd9e6;
}
.rearrange-ghost div p {
  color: #a4a3a1;
}
</style>
